const button = "_61b4o95jm";
const icon = "_61i1lwd84y";

export { button, icon };
import "./atom.favourite-button.style.linaria.module.css";
//# sourceMappingURL=atom.favourite-button.style.js.map
